import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import FormSelectBox from "../controls/FormSelectBox";

const PriceTypes = ({ id, onSelect, priceTypesList }) => {
  const { t, i18n } = useTranslation();
  const [priceTypes, setPriceTypes] = useState([]);
  const [loading, setLoading] = useState(true);
  const [selectedId, setSelectedId] = useState(id || "");

  useEffect(() => {
    fetch(`${process.env.REACT_APP_API_BASE_URL}/api/PriceType/Default`)
      .then((response) => {
        if (!response.ok) throw new Error("Erreur lors du chargement");
        return response.json();
      })
      .then((data) => {
        setPriceTypes(data);
        priceTypesList?.(data);
        setLoading(false);
      })
      .catch((error) => {
        console.error("Erreur lors du chargement des types de prix:", error);
        setLoading(false);
      });
  }, []);

  useEffect(() => {
    if (!loading && id) {
      setSelectedId(id);
    }
  });

  const handleChange = (name, newId) => {
    setSelectedId(newId);
    onSelect(newId);
  };

  return (
    <FormSelectBox
      label={t("priceType.label")}
      name="priceTypeId"
      value={selectedId}
      onChange={handleChange}
      options={priceTypes.map((type) => ({
        id: type.id,
        name: i18n.language === "fr" ? type.nameFr : type.nameEn,
      }))}
      required={true}
      error={loading ? t("priceType.loading") : ""}
      placeholder={t("priceType.placeholder")}
    />
  );
};

export default PriceTypes;
